import type { IUser } from "@src/types/AppTypes";
import { createContext } from "react";

export const UserContext = createContext<IUser | null>(null);

export const UserDispatchContext = createContext<
  React.Dispatch<
    | { type: "updateUser"; payload: IUser }
    | { type: "setUser"; payload: IUser | null }
  >
>(() => {});

export function userReducer(
  state: IUser | null,
  action:
    | { payload: IUser; type: "updateUser" }
    | { payload: IUser | null; type: "setUser" }
) {
  switch (action.type) {
    case "updateUser":
      return { ...state, ...action.payload };

    case "setUser":
      return action.payload;

    default:
      return state;
  }
}
